import { render, staticRenderFns } from "./StudyProgramMajor.vue?vue&type=template&id=6abaee0e&"
import script from "./StudyProgramMajor.vue?vue&type=script&lang=js&"
export * from "./StudyProgramMajor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports